"use client";
import React from "react";

import Head from "next/head";
import { useTranslations } from "next-intl";
import { useRouter } from "../../navigation";
import { useForm } from "react-hook-form";
import { Form, FormField } from "../../modules/theme/components/Form";
import Button from "../../modules/theme/components/Button";
import useFormValidators from "../../modules/theme/hooks/useFormValidators";

export default function NotFound({ searchQuery = "" }) {
  const t = useTranslations();
  const { required } = useFormValidators();

  const router = useRouter();
  const methods = useForm({
    defaultValues: {
      query: searchQuery,
    },
  });

  const onSubmit = ({ query }) => {
    router.push(`/search/${encodeURIComponent(query)}`);
  };

  const { handleSubmit, register } = methods;
  return (
    <>
      <Head>
        <title>{t("error_404_title")}</title>
      </Head>
      <div className="error-area d-flex align-items-center justify-content-center flex-column text-center">
        <div className="px-3">
          <div className="error-code">404</div>
          <h1 className="mt-0">{t("error_404_title")}</h1>
          <p className="mb-0">{t("error_404_content")}</p>
          <p className="mt-0">{t("error_404_search")}</p>
          <div className="search-bar my-4">
            <span className="search-wrap">
              <Form
                className="position-relative w-lg-50 mx-auto"
                onSubmit={handleSubmit(onSubmit)}
                method="POST"
              >
                <FormField
                  {...register("query", {
                    required,
                  })}
                  name="query"
                  type="text"
                  id="search-desktop"
                  className="form-field border-0"
                  placeholder={t("search")}
                  label={t("search")}
                />

                <Button
                  appearance="primary"
                  type="submit"
                  aria-label="Search"
                  icon="search"
                />
              </Form>
            </span>
          </div>
          <div className="button-group justify-content-center mt-5">
            <Button appearance="tertiary" href="/">
              {t("back_to_home")}
            </Button>
            <Button href="/contact" appearance="tertiary">
              {t("contact_us")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
